import moment from 'moment-timezone'
import { helper } from 'services'

export function prepareExtendData (item, location, actionType) {
  let now = moment(moment(), ['YYYY-MM-DD HH:mm:ss']).tz(location.timezone.code)
  let history = item.history
  const isV2 = history.reservation && history.reservation.version === 'v2'

  let form = {
    reservation_number: history.reservation ? history.reservation.reservation_number : null,
    location_id: location.id,
    email: history.email,
    phone: history.phone,
    reserved_for: history.reserved_for,
    state: history.state,
    items: isV2 ? {} : [],
    coupon_discount: history.coupon_discount > 0 ? history.coupon_discount.toFixed(2) : null,
    extend_when_checkout: true,
  }

  _.forEach(history.extra_fields, (field) => {
    form[field.name] = field.value
  })

  _.forEach(history.dates, (date) => {
    if (date.type_type == 'bundle') {
      form.bundle_id = date.type_id
      return
    }

    const from_date = date.id == item.id && actionType == 'check-in' ? now.format('YYYY-MM-DD HH:mm:ss') : date.from_date
    const to_date = date.id == item.id && actionType == 'check-out' ? now.format('YYYY-MM-DD HH:mm:ss') : date.to_date

    if (isV2) {
      if (date.type_type == 'room') {
        if (!form.items.rooms) {
          form.items.rooms = []
        }

        const roomItem = {
          id: date.id,
          from_date,
          to_date,
          number_of_spots: null,
          number_of_rooms: date.number_of_units,
          type_id: date.type_id,
          guests: date.guest_names,
          guests_in_rooms: date.number_of_guests,
        }

        roomItem.guests = _.slice(roomItem.guests, 0, Number(roomItem.number_of_rooms))
        roomItem.guests_in_rooms = _.slice(roomItem.guests_in_rooms, 0, Number(roomItem.number_of_rooms))
        form.items.rooms.push(roomItem)
      } else if (date.type_type == 'parking') {
        form.items.parking = {
          id: date.id,
          from_date,
          to_date,
          number_of_spots: date.number_of_units,
          number_of_rooms: null,
          type_id: helper.resolveTpsParkingTypeId(date),
          guest_names: null,
          guests_in_rooms: null,
        }
      }
    } else {
      form.items.push({
        id: date.id,
        from_date,
        to_date,
        type: date.type_type,
        number_of_spots: date.type_type == 'parking' ? date.number_of_units : null,
        number_of_rooms: date.type_type == 'room' ? date.number_of_units : null,
        type_id: helper.resolveTpsParkingTypeId(date),
        guest_names: date.type_type == 'room' ? date.guest_names : null,
        guests_in_rooms: date.type_type == 'room' ? date.number_of_guests : null,
      })
    }
  })

  if (!isV2) {
    form.items = _.map(form.items, (date) => {
      if (date.type == 'room') {
        date.guest_names = _.slice(date.guest_names, 0, Number(date.number_of_rooms))
        date.guests_in_rooms = _.slice(date.guests_in_rooms, 0, Number(date.number_of_rooms))
      }

      return date
    })
  }

  return form
}

export function isEarlyCheckinAllowed (now, fromDate, timezoneCode) {
  let startDate = moment(fromDate).tz(timezoneCode, true)
  let earlyCheckinAllowedFrom = startDate.clone().subtract(3, 'days')
  return !now.isBefore(earlyCheckinAllowedFrom)
}

export function getEarlyCheckinExtendDetails (costs, costsActiveHistory, from, now) {
  let amount_to_pay = 0

  if (costs && costsActiveHistory) {
    if (costsActiveHistory.due_at_location_total > 0) {
      amount_to_pay = (costs.reservation.due_at_location - costsActiveHistory.due_at_location_total).toFixed(2)
    } else {
      amount_to_pay = (costs.reservation.grand_total - costsActiveHistory.grand_total).toFixed(2)
    }
  }

  let duration = moment.duration(from.diff(now))
  let totalHours = duration.asHours()
  let hours = Math.floor(totalHours)
  let minutes = Math.floor(duration.asMinutes() % 60)
  let diff = hours + ':' + (minutes < 10 ? '0' + minutes : minutes)

  if (totalHours <= 3) {
    amount_to_pay = 0
  }

  return { amount_to_pay, diff }
}
